import React, { useState } from "react";
import Layout from "./layout/Layout";
import MenuIcons from "./MenuIcons";
import MenuButtons from "./MenuButtons";
import Colors from "./Colors";
import Alerts from "./Alerts";
import Fields from "./Fields";

const menu = {
  icons: <MenuIcons />,
  buttons: <MenuButtons />,
  colors: <Colors />,
  alerts: <Alerts />,
  fields: <Fields />,
};

const Index = () => {
  const [currentMenu, setCurrentMenu] = useState("icons");

  return (
    <Layout
      title="Docs v1"
      handleClick={(menuName) => {
        setCurrentMenu(menuName);
      }}
    >
      {menu[currentMenu] || menu["icons"]}
    </Layout>
  );
};

export default Index;
